import axios from 'axios';

// Default API base URL for development. Change via env if needed.
// axios.defaults.baseURL = (typeof process !== 'undefined' && process.env.REACT_APP_API_URL) ? process.env.REACT_APP_API_URL : 'http://localhost:5000';
const configuredApiUrl = process.env.REACT_APP_API_URL || 'http://localhost:5000';
const loopbackHosts = new Set(['localhost', '127.0.0.1', '::1']);
const withoutWww = hostname => hostname.replace(/^www\./i, '');

const isApexWwwPair = (first, second) => (
	first !== second && withoutWww(first) === withoutWww(second)
);

export const getBrowserAccessibleApiUrl = (
	apiUrl,
	browserLocation = typeof window === 'undefined' ? null : window.location
) => {
	if (!browserLocation) return apiUrl;

	try {
		const resolvedUrl = new URL(apiUrl, browserLocation.origin);
		if (loopbackHosts.has(resolvedUrl.hostname) && !loopbackHosts.has(browserLocation.hostname)) {
			resolvedUrl.hostname = browserLocation.hostname;
		} else if (isApexWwwPair(resolvedUrl.hostname, browserLocation.hostname)) {
			resolvedUrl.protocol = browserLocation.protocol;
			resolvedUrl.hostname = browserLocation.hostname;
			resolvedUrl.port = browserLocation.port;
		}
		return resolvedUrl.toString().replace(/\/$/, '');
	} catch (e) {
		return apiUrl;
	}
};

axios.defaults.baseURL = getBrowserAccessibleApiUrl(configuredApiUrl);

// attach token from localStorage (if present)
try {
	const token = localStorage.getItem('token');
	if (token) axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
} catch (e) { }

export default axios;
